import { css } from 'lit';
import resetStyles from './reset.styles';
export default css `
    ${resetStyles}
    :host {
        position: relative;
        box-sizing: border-box;
    }
    :host *,
    :host *::before,
    :host *::after {
        box-sizing: inherit;
    }
    [hidden] {
        display: none !important;
    }

    /* COLORS */
    .simple {
        --mode-color: var(--sgdf-color-default);
        --mode-color-light: var(--sgdf-color-primary-50);
        --mode-color-hover: var(--sgdf-color-default);
    }

    .primary {
        --mode-color: var(--sgdf-color-default);
        --mode-color-light: var(--sgdf-color-primary-50);
        --mode-color-hover: var(--sgdf-color-default-hover);
    }

    .success {
        --mode-color: var(--sgdf-color-success-600);
        --mode-color-light: var(--sgdf-color-success-50);
        --mode-color-hover: var(--sgdf-color-success-700);
    }

    .neutral {
        --mode-color: var(--sgdf-color-neutral-600);
        --mode-color-light: var(--sgdf-color-neutral-50);
        --mode-color-hover: var(--sgdf-color-neutral-700);
    }

    .warning {
        --mode-color: var(--sgdf-color-warning-600);
        --mode-color-light: var(--sgdf-color-warning-50);
        --mode-color-hover: var(--sgdf-color-warning-700);
    }

    .danger {
        --mode-color: var(--sgdf-color-danger-600);
        --mode-color-light: var(--sgdf-color-danger-50);
        --mode-color-hover: var(--sgdf-color-danger-700);
    }

    .form-error:not([disabled])::part(label),
    .form-error:not([disabled])::part(help-text) {
        color: var(--sl-color-danger-600);
    }

    .form-error:not([disabled])::part(control),
    .form-error:not([disabled])::part(base) {
        border-color: var(--sl-color-danger-500);
    }
`;
// All components import this file, so it's a good place to ensure utility styles are applied to the light DOM
const style = document.createElement('style');
document.head.append(style);
//# sourceMappingURL=component.styles.js.map